import React from 'react';
import { Container, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
    },
}));

const PageContainer = ({ children, maxWidth = 'lg', ...props }) => {
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: 'white' }}>
            <StyledContainer maxWidth={maxWidth} {...props}>
                {children}
            </StyledContainer>
        </Box>
    );
};

export default PageContainer; 